import React from 'react';
import './listagarantia.css';
import {useState, useEffect} from 'react';
import api from '../../services/api.js';

function ListaMonit(){

    let [dados,setdados] = useState([])


    async function CarregaGarantia()
    {

      //  const user = localStorage.getItem("IdUsuario");
        const cnpj = localStorage.getItem("usuario");
        const resultado = await api.get('/cliente/home/garantia.php/?e='+cnpj);
        
      setdados(resultado.data)       

    }

    useEffect(()=>{
          CarregaGarantia()
    },[]
    );

    return <table className="table table-hover table-bordered">
            <thead className="table-secondary">
                <tr>
                    <th scope="col">Nº Proposta</th>
                    <th scope="col">Serviço</th> 
                    <th scope="col">Garantia Até</th>               
                </tr>
            </thead>
            <tbody >                  
                  { dados.map(function(dado){
                                return <tr>
                                 <th scope="row">{dado.Proposta} </th>
                                 <th scope="row" >{dado.NomeServico}</th>
                                 <th scope="row" >{dado.Garantia}</th>                                 
                                 </tr>
                         })

                         }
                
            </tbody>
        </table>

}

export default ListaMonit;